import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/core/app.state';
import { IComProducts, IExecuteSeccess } from 'src/app/features/imports/models/imports.models';



import { LocalStorageService } from 'src/app/shared/localstorage.service';
import { DetailsComparator, SetComparatorLoader } from '../../store/comparator.actions';
import { SetCurrentElementId } from 'src/app/shared/store/shared.actions';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-filter-details-comparator',
  templateUrl: './filter-details-comparator.component.html',
  styleUrls: ['./filter-details-comparator.component.scss']
})
export class FilterDetailsComparatorComponent implements OnInit {

  comparatorsFilters = LocalStorageService.get('comparatorsFilters');

  comparatortId!: number;
  filterNameControl = new FormControl('', Validators.required);
  selectedGroup = 'group_info';
  comparatorFilter: IComProducts[] = [];
  products: IComProducts[] = [];
  filterName = '';
  toggleSaveFilterForm = false;
  filterForm: FormGroup = new FormGroup({});
  filter: any;
  constructor(
    public dialogRef: MatDialogRef<FilterDetailsComparatorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private store: Store<AppState>,
    private router: Router,
    private route: ActivatedRoute,
    
    
  ) { }

  ngOnInit(): void {
    this.createForm()
  }
  createForm() {
    this.filterForm = this.fb.group({
      sku: [this.data?.sku ?? ''],
      name: [this.data?.name ?? ''],
      imported_price_min: [this.data?.imported_price_min ?? ''],
      imported_price_max: [this.data?.imported_price_max ?? ''],
      inventory_price_min: [this.data?.inventory_price_min ?? ''],
      inventory_price_max: [this.data?.inventory_price_max ?? ''],
      other_prices_min: [this.data?.other_prices_min ?? ''],
      other_prices_max: [this.data?.other_prices_max ?? ''],
    });
  }
  getFiltersCount(): number {
    let count = 0;
    if (this.filterForm.value.sku) {
      count++;
    }
    if (this.filterForm.value.name) {
      count++;
    }
    if (this.filterForm.value.imported_price_min) {
      count++;
    }
    if (this.filterForm.value.imported_price_max) {
      count++;
    }
    if (this.filterForm.value.inventory_price_min) {
      count++;
    }
    if (this.filterForm.value.inventory_price_max) {
      count++;
    }
    if (this.filterForm.value.better_offer_min) {
      count++;
    }
    if (this.filterForm.value.better_offer_max) {
      count++;
    }
    if (this.filterForm.value.date_imported_from) {
      count++;
    }
    if (this.filterForm.value.date_imported_to) {
      count++;
    }
    return count;
  }
  close(): void {
    this.dialogRef.close();
  }

  clearFilters(): void {
    this.filterForm.reset();  
  }



  toggleSaveFilter(): void {
    this.toggleSaveFilterForm = !this.toggleSaveFilterForm;
  }


  save(): boolean | void {
    if (this.filterForm.valid) {
      const filter = {
        name: this.filterForm.value.name,
        imported_price_min: this.filterForm.value.imported_price_min,
        imported_price_max: this.filterForm.value.imported_price_max,
        inventory_price_min: this.filterForm.value.inventory_price_min,
        inventory_price_max: this.filterForm.value.inventory_price_max,
        better_offer_min: this.filterForm.value.better_offer_min,
        better_offer_max: this.filterForm.value.better_offer_max,
        date_imported_from: this.filterForm.value.date_imported_from,
        date_imported_to: this.filterForm.value.date_imported_to
      };
      this.filterForm.reset();
      this.dialogRef.close(filter);
    }
  }

  setFilter(filter: any): void {
    if (filter) {
      this.filterName = filter.name;
    }
  }

deleteFilter(filterName: string): void {
  this.filterForm.removeControl(filterName);
}

applyFilter(): void {
  this.dialogRef.close(this.filterForm.value);
}
}

